module.exports = __webpack_public_path__ + "6bf2a760c8298976920fde6b715b5f38.svg";